
import React from 'react'
import { I18n } from '@front/volcanion'

import { InformationDialog, ConfirmationDialog, DialogContent, FormDialog, ModelFormDialog } from '@front/squirtle'
import SimulatorDialog from '@abra/elements/Popup/SimulatorDialog'
import ShortcutHelper from '@abra/elements/Popup/ShortcutHelper'
import { ReasonDialog } from '@front/squirtle/elements'

import IdentifierPinForm from './IdentifierPinForm'
import UnauthorizedScheduleDialog from './UnauthorizedSchedule'
import TrafficAlertDialog from './TrafficAlert'
import SendCommentForm from './SendComment'
import ManualDispatchForm from './ManualDispatch'
import SendMessageDriverForm from './SendMessageDriver'
import CancelGrouped from './CancelGrouped'
import NotifyDrivers from './NotifyDrivers'
import shortcuts from './shortcuts'
import ConfirmationOptionsDialog from './ConfirmationOptions'
import ShowDuplicateOrdersPopup from './ShowDuplicateOrders'

const Dialogs = props => {
  const {
    record_id,
    onCloseScheduleInformation,
    onCloseTrafficAlertInformation,
    onCloseInformationValidation,
    handleSendComment,
    handleManualDispatch,
    handleBeforeManualDispatch,
    handleOpenManualDispatch,
    handleSendMessageDriver,
    handleRedispatch,
    handleCancel,
    handleConfirmOptions,
    onSubmitIdentifierPinForm,
    getFailedNotificationIdentifierPin,
    handleNotifyDrivers,
    getNotifyDriversFailedNotification,
    notifyDriversRecordToForm,
    handleConfirmLimitExceeded
  } = props

  return <>
    <FormDialog
      name={'identifier_pin_form'}
      title={I18n.t('identifier.label.alter')}
      formProps={{
        onSubmit: onSubmitIdentifierPinForm,
        getFailedNotification: getFailedNotificationIdentifierPin
      }}
    >
      <DialogContent>
        <IdentifierPinForm order_id={record_id} />
      </DialogContent>
    </FormDialog>

    <FormDialog
      name={'cancel_confirmation'}
      formProps={{
        onSubmit: (values) => handleCancel(true, values?.reason, values?.cancelation_comment)
      }}
    >
      <DialogContent>
        <ReasonDialog order_id={record_id} type='cancel' />
      </DialogContent>
    </FormDialog>

    <ConfirmationDialog name={'cancel_order_grouped'} onConfirm={() => handleCancel(true)}>
      <DialogContent>
        <CancelGrouped />
      </DialogContent>
    </ConfirmationDialog>
    <ConfirmationDialog name={'claim_confirmation'} onConfirm={handleRedispatch} />
    <FormDialog
      name={'redispatch_confirmation'}
      formProps={{
        onSubmit: handleRedispatch
      }}
    >
      <DialogContent>
        <ReasonDialog order_id={record_id} type='redispatch' />
      </DialogContent>
    </FormDialog>
    <ConfirmationDialog name={'dispatch_confirmation'} onConfirm={() => handleOpenManualDispatch(true)} />
    <FormDialog
      name={'order_send_comment'}
      title={I18n.t('comment.operator')}
      formProps={{
        onSubmit: handleSendComment,
        initialValues: {
          title: I18n.t('comment.label', { count: 1 }),
        }
      }}
    >
      <DialogContent>
        <SendCommentForm />
      </DialogContent>
    </FormDialog>
    <FormDialog
      name={'dispatch_manual_form'}
      maxWidth='xl'
      formProps={{
        onSubmit: handleManualDispatch,
        submitOnEnter: true,
        beforeSubmit: handleBeforeManualDispatch
      }}
    >
      <DialogContent>
        <ManualDispatchForm />
      </DialogContent>
    </FormDialog>

    <FormDialog
      name={'order_send_message_driver'}
      formProps={{
        onSubmit: handleSendMessageDriver,
        initialValues: { title: I18n.t('info.order') }
      }}
    >
      <DialogContent>
        <SendMessageDriverForm />
      </DialogContent>
    </FormDialog>

    <InformationDialog name={'default_dialog_information'} />

    <InformationDialog name={'traffic_alert_information'} maxWidth={'md'} onClose={onCloseTrafficAlertInformation}>
      <DialogContent>
        <TrafficAlertDialog />
      </DialogContent>
    </InformationDialog>

    <InformationDialog name={'unauthorized_schedule_information'} onClose={onCloseScheduleInformation}>
      <DialogContent>
        <UnauthorizedScheduleDialog />
      </DialogContent>
    </InformationDialog>

    <InformationDialog name={'shortcuts_helper'} maxWidth={'lg'}>
      <DialogContent>
        <ShortcutHelper shortcuts={shortcuts} />
      </DialogContent>
    </InformationDialog>

    <SimulatorDialog order_id={record_id} />

    <InformationDialog
      name={'validation_information'}
      maxWidth={'md'}
      onClose={onCloseInformationValidation}
      _header={{ textAlign: 'center', fontSize: 20, color: 'secondary.600' }}
      _description={{ sx: { textAlign: 'center', fontSize: 16, color: 'primary.600' } }}
    />
    <ModelFormDialog
      name='notify_drivers'
      submitLabel={I18n.t('action.send')}
      maxWidth='md'
      title={I18n.t('order.popup.notify_drivers.title')}
      formProps={{
        record_id,
        model_name: 'order',
        onSubmit: handleNotifyDrivers,
        recordToForm: notifyDriversRecordToForm,
        getFailedNotification: getNotifyDriversFailedNotification,
        populate: [
          'driver_opts',
          'vehicle_opts',
          'service.contract.company',
          'source',
          'destination',
          'payment_type',
          'commercial_package'
        ],
        includeReadOnly: true,
        submitChangesOnly: false,
        disableParentSubmitListener: true
      }}
    >
      <DialogContent>
        <NotifyDrivers />
      </DialogContent>
    </ModelFormDialog>

    <ConfirmationDialog name='confirmation_options' onConfirm={handleConfirmOptions}>
      <DialogContent>
        <ConfirmationOptionsDialog />
      </DialogContent>
    </ConfirmationDialog>
    <ShowDuplicateOrdersPopup />
    <ConfirmationDialog name='order_limit_exceeded' onConfirm={handleConfirmLimitExceeded} />
  </>
}

export default React.memo(Dialogs)
